import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductSectionComponentBase } from '../../../ProductSectionComponentBase';
import { ProductSectionComponent } from '../../product-section';
import { ProductLongDescriptionComponent } from '../product-long-description/product-long-description.component';

@Component({
  selector: 'ideal-product-long-description-section',
  imports: [ProductSectionComponent, ProductLongDescriptionComponent],
  templateUrl: './product-long-description-section.component.html',
  styleUrl: './product-long-description-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.display]': 'hasContent() ? undefined : "none"',
  },
})
export class ProductLongDescriptionSectionComponent extends ProductSectionComponentBase {}
